export enum IdentificationDocumentCode {
  CC = 'CC',
  CE = 'CE',
  NIT = 'NIT',
  PA = 'PA',
}

export class IdentificationDocument {
  constructor(public readonly code: IdentificationDocumentCode, public readonly value: string) {
    let isValid = false;
    switch (code) {
      case IdentificationDocumentCode.CC:
        isValid = new RegExp(/^[1-9][0-9]{3,9}$/).test(value);
        break;
      case IdentificationDocumentCode.CE:
        isValid = new RegExp(/^([a-zA-Z]{1,5})?[1-9][0-9]{3,7}$/).test(value);
        break;
      case IdentificationDocumentCode.NIT:
        isValid = new RegExp(/^[1-9]\d{6,9}$/).test(value);
        break;
      case IdentificationDocumentCode.PA:
        isValid = new RegExp(/^[a-zA-Z0-9_]{4,16}$/).test(value);
        break;
      default:
        isValid = false;
        break;
    }

    if (!isValid) throw new Error('Identification document not valid');
  }
}
